import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const PartnerFilialManagement = {
  PartnerBranches: lazyNamed(() => import('./containers/index.ts'), 'PartnerBranches'),
};
